/**
 * Removes properties with `undefined` values from an object.
 * Firestore setDoc / updateDoc throws errors when fields contain `undefined`.
 */
export function sanitizeFirestoreData<T extends Record<string, any>>(data: T): Record<string, any> {
  const cleanData: Record<string, any> = {};
  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined) {
      if (value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
        cleanData[key] = sanitizeFirestoreData(value);
      } else if (Array.isArray(value)) {
        cleanData[key] = value.map((item) =>
          item && typeof item === 'object' && !(item instanceof Date)
            ? sanitizeFirestoreData(item)
            : item
        );
      } else {
        cleanData[key] = value;
      }
    }
  }
  return cleanData;
}
